import { useState, useEffect, useRef } from "react";
import Sidebar from "./Sidebar/Sidebar";
import { MdMenu } from "react-icons/md";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { useLocation } from "react-router";
import { userLogoutOp } from "../redux/operations/user.operations";
import { Link } from "react-router-dom";
import moment from "moment";
import Profile from "../Components/profile/Profile";
import { FaRegCalendarAlt } from "react-icons/fa";
import { Card, Typography } from "@mui/material";
import { useMediaQuery } from "react-responsive";
import TopNavbar from "./TopNavbar";

function RootLayout({ children }) {
  let isTabletMid = useMediaQuery({ query: "(max-width: 2560px)" });
  const [open, setOpen] = useState(isTabletMid ? false : true);
  const userData = useSelector((state) => state.user);
  const [showMenu, setShowMenu] = useState(false);
  console.log(
    "🚀 ~ file: RootLayout.jsx:16 ~ RootLayout ~ showMenu:",
    showMenu
  );
  const { user } = useSelector((state) => state || {});
  const todayDate = moment().format("LL");

  const menuRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const handleProfileClick = () => {
    setShowMenu((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setShowMenu(false);
    }
  };

  useEffect(() => {
    if (showMenu) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [showMenu]);

  const handleLogout = () => {
    dispatch(userLogoutOp());
    localStorage.removeItem("userAuthToken");
    localStorage.removeItem("locationIp");
    navigate("/seva-login");
  };

  return (
    <div className="flex h-screen overflow-hidden bg-blue-50 font-montsettat">
      {/* {user.role !== "Director" &&  <Sidebar open={open} setOpen={setOpen} />} */}
      <div>
        <Sidebar open={open} setOpen={setOpen} />
      </div>
      <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
        <main>
        <TopNavbar  setOpen={setOpen}/>
          {/* {location.pathname !== "/dashboard" && (
          <div className="bg-blueBg flex shadow-lg items-center flex-row justify-between mb-2 pl-4 p-4 sticky top-0 z-[998]">
           
            <div className="flex flex-row items-center gap-4">
              {userData.role !== "Director" && (
              <div
                className="md:hidden cursor-pointer"
                onClick={() => setOpen(true)}
              >
                <MdMenu size={30} className="text-white" />
              </div>
               )} 

              <Typography variant="h5" className="text-white font-bold">
                SEVA Grievance
              </Typography>
            </div>
            {userData.role === "Director" && (
              <nav className="mx-2 my-3 flex flex-col space-y-3 md:flex-row md:space-x-6 md:space-y-0 text-white font-semibold">
                <Link
                  to="https://www.rammnk.com"
                  target="_blank"
                  className="transition-transform hover:scale-105"
                >
                  Home
                </Link>
                <Link
                  to="/dashboard"
                  className="transition-transform hover:scale-105"
                >
                  Dashboard
                </Link>
                <Link
                  to="/calendar"
                  className="transition-transform hover:scale-105"
                >
                  Calendar
                </Link>
                <Link
                  onClick={handleLogout}
                  className="transition-transform hover:scale-105"
                >
                  Logout
                </Link>
              </nav>
            )}
           
            <Profile />
           
            <div className="text-xl md:text-2xl text-white font-bold lg:pr-12 flex relative">
                <div
                  className="hidden w-full md:block md:w-auto"
                  id="navbar-default"
                >
                  <ul className="flex flex-col mt-4 border border-gray-100 rounded-lg md:flex-row md:items-center md:space-x-8 md:mt-0 md:text-sm md:font-medium md:border-0 text-neutral-700">
                    <li>
                      <Link
                        to="https://www.rammnk.com"
                        target="_blank"
                        className="block pl-3 pr-4 text-white text-lg rounded md:border-0 md:p-0 font-montsettat transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300 font-semibold"
                      >
                        Home
                      </Link>
                    </li>
                    <li>
                      <span className="block cursor-pointer pl-3 pr-4 text-lg text-white rounded md:border-0 md:p-0 font-montsettat transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300 font-semibold">
                        Hi, Welcome {user.firstName || user?.email}
                      </span>
                    </li>
                    <Profile />
                  </ul>
                </div>
              </div>
          </div>
           )} */}
          <div className="mx-4 xl:mx-6 my-2">{children}</div>
        </main>
      </div>
    </div>
  );
}

export default RootLayout;
